import Particles, { ParticlesProvider } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";

// Defined outside component to maintain a stable reference across renders
const particlesInit = async (engine) => {
  await loadSlim(engine);
};

const ParticlesBackground = () => {
  return (
    <ParticlesProvider init={particlesInit}>
      <Particles
        id="tsparticles"
        options={{
          fullScreen: {
            enable: true,
            zIndex: -1,
          },
          background: {
            color: {
              value: "transparent",
            },
          },
          fpsLimit: 120,
          interactivity: {
            detectsOn: "window",
            events: {
              onHover: {
                enable: true,
                mode: "repulse",
              },
              onClick: {
                enable: true,
                mode: "push",
              },
              resize: true,
            },
            modes: {
              repulse: {
                distance: 150,
                duration: 0.4,
                speed: 1,
              },
              push: {
                quantity: 4,
              },
            },
          },
          particles: {
            color: {
              value: ["#ffffff", "#854CE6", "#38bdf8"],
            },
            links: {
              enable: true,
              color: "#854CE6",
              distance: 150,
              opacity: 0.4,
              width: 1,
              triangles: {
                enable: true,
                color: "#854CE6",
                opacity: 0.15,
              },
            },
            move: {
              enable: true,
              speed: 1.2,
              direction: "none",
              random: false,
              straight: false,
              outModes: {
                default: "bounce",
              },
            },
            number: {
              density: {
                enable: true,
                area: 800,
              },
              value: 85,
            },
            opacity: {
              value: { min: 0.3, max: 0.7 },
            },
            shape: {
              type: "circle",
            },
            size: {
              value: { min: 1.5, max: 3.5 },
            },
          },
          detectRetina: true,
        }}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          zIndex: -1,
          pointerEvents: "none",
        }}
      />
    </ParticlesProvider>
  );
};

export default ParticlesBackground;